module.exports = __webpack_public_path__ + "static/media/Tankekontrollerende_Toner.f28ff3bf.md";